import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { EditorialTeamView, getEditorialTeamOptions } from '@/module/Author/EditorialTeam';

export const Route = createFileRoute('/_auth/author/_author/editorial-team/_editorialTeam/$editorialTeamId/_layout/')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.view' },
  },
});

function RouteComponent() {
  const { editorialTeamId } = Route.useParams();
  const { data: editorialTeam } = useSuspenseQuery(getEditorialTeamOptions(editorialTeamId));

  return <EditorialTeamView editorialTeam={editorialTeam} />;
}
